export const environment = {
  production: false,
  configFile: 'config',
  ga: '',
  hotjar: '00000000'
}
